import { render, staticRenderFns } from "./InstructionalMethodView.vue?vue&type=template&id=6c5a7758&scoped=true"
import script from "./InstructionalMethodView.vue?vue&type=script&lang=js"
export * from "./InstructionalMethodView.vue?vue&type=script&lang=js"
import style0 from "./InstructionalMethodView.vue?vue&type=style&index=0&id=6c5a7758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5a7758",
  null
  
)

export default component.exports